<template>
  <v-card class="pa-0 elevation-0">
    <v-combobox
      v-model="selected"
      item-value="id"
      item-text="name"
      :items="options"
      :color="selectColor"
      :placeholder="placeholder"
      :disabled="disabled"
      :dense="dense"
      clearable
      hide-details
      @change="change($event)"
      ref="input"
      >
      <template v-slot:label>
        <span :class="selectLabelClass">{{ label }}</span>
      </template>
      <template v-if="showButton" v-slot:append-outer>
        <v-btn 
          @click="$emit('click')"
          :disabled="disableButton"
          :dark="!disableButton"
          :color="buttonColor"
          :loading="buttonLoading"
          ><v-icon>{{ buttonIcon }}</v-icon>
        </v-btn>
      </template>
    </v-combobox>
    <p v-if="error" class="red--text">{{ error }}</p>
  </v-card>
</template>

<script>
import { AppColor } from '../config'

export default {
  name: 'KioskCombobox',
  emits: ['input'],
  $_veeValidate: {
    name () {
      return this.label
    },
    value () {
      return this.selectedId
    }
  },
  props: {
    options: {
      type: Array,
      default: null
    },
    value: {
      type: Number,
      default: null
    },
    label: {
      type: String
    },
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    showButton: {
      type: Boolean,
      default: false
    },
    buttonColor: {
      type: String,
      default: AppColor.Medium
    },
    buttonIcon: {
      type: String,
      default: 'arrow_forward'
    },
    buttonLoading: {
      type: Boolean,
      default: false
    },
    validationRule: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      selected: { id: 0, name: this.getExpression('Alert', 'NoKiosk') },
      noSelection: { id: 0, name: this.getExpression('Alert', 'NoKiosk') }
    }
  },
  computed: {
    selectedId () {
      return this.value
    },
    disableButton () {
      return this.selectedId <= 0 || this.selectedId === null || this.buttonLoading
    },
    selectColor () {
      return this.error
        ? 'red'
        : ''
    },
    selectLabelClass () {
      return this.error
        ? 'red--text'
        : ''
    }
  },
  methods: {
    change (e) {
      const value = e !== undefined
        ? e.id
        : null
      this.$emit('input', value)
    },

    setValue () {
      const self = this
      const kiosks = self.options.filter(o => o.id === self.selectedId)
      self.selected = kiosks.length > 0
        ? kiosks[0]
        : self.placeholder != null
          ? null
          : self.noSelection
    },

    focus () {
      this.$refs.input.focus()
    },

    buttonClick () {
      this.$emit('click')
    }
  },
  watch: {
    selectedId () {
      this.setValue()
    }
  }
}
</script>